/**
 * Pulsing status indicator: a solid centre dot with two thin rings that expand
 * and fade in sequence (≈2s cycle). Words next to it never move; rings are
 * drawn outside the layout box so they neither clip nor shift alignment.
 * `tone="red"` → red dot/rings (on petrol «عاجل»); `tone="white"` → white dot,
 * light rings (on red «مباشر»). Always animated (product decision) — calm 2s cycle.
 */
export default function LiveDot({ tone = "red", className = "", testId = "live-dot" }) {
    return (
        <span className={`live-indicator live-indicator--${tone} ${className}`} aria-hidden="true" data-testid={testId}>
            <span className="live-indicator__ring live-indicator__ring--1" />
            <span className="live-indicator__ring live-indicator__ring--2" />
            <span className="live-indicator__dot" />
        </span>
    );
}
